import { offerwallapi } from "../config/axiosconfig"


export const analytics = async (data, type) => {
    return await offerwallapi.post("/api/analytics", data, {
        params: {
            type
        }
    });
}